// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"412":"34f1c9d5","908":"ab48a950"}[chunkId] + ".chunk.js";
};